
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import UpsellItemQuantity from '@/components/UpsellItemQuantity.vue';
import BasketModule from '@/store/modules/basket';

@Component({
  components: {
    UpsellItemQuantity,
  }
})
export default class UpsellModal extends Vue {
  @Prop() isMobile!: boolean;
  @Prop() upsellGroups: Product[];
  @Getter basketUpsellItems!: BasketUpsellGroup;
  name = 'UpsellModal';

  selectedItems: { [key: string]: boolean };
  selectedItemsQuantity: { [key: string]: number };

  data() {
    return {
      selectedItems: {},
      selectedItemsQuantity: {},
    }
  }

  @Emit('close')
  close(event) {
    return event;
  }

  updateValue(event, item) {
    const { checked } = event?.target || {};
    this.$set(this.selectedItems, item.id, !!checked);
  }

  async handleSubmitItems() {
    try {
      const basketUpsellItems = Object.keys(this.selectedItems).reduce((acc: BasketAddUpsellPostItem[], id) => {
        if (this.selectedItems[id]) {
          const usItem: BasketAddUpsellPostItem = { id: parseInt(id, 10), quantity: this.selectedItemsQuantity[id] };
          acc.push(usItem);
        }
        return acc;
      }, [])
      await BasketModule.addUpsellItems({ basketUpsellItems });
      this.$toasted.success('Your items were successfully added!');
      this.close('addUpsellItems: success');
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
      this.close('addUpsellItems: failed');
    }
  }

  get basketUpsellItemGroups() {
    return this.basketUpsellItems?.groups || [];
  }

  get hasItemsToApply() {
    return Object.keys(this.selectedItems).some((id) => this.selectedItems[id]);
  }
}
